import { Component } from '@angular/core';

@Component({
  selector: 'dram-footer',
  templateUrl: './dram-footer.component.html',
  styleUrls: ['./dram-footer.component.css']
})
export class DramFooterComponent {
  icons = {
    logoBuro: './assets/icons/buro-logo.png',
    logoCondusef: 'assets/icons/footer-icon2.png',
    logoBanxico: 'assets/icons/footer-icon3.png'
  };

  facebookHovered = false;
  instagramHovered = false;

  openInstagram() {
    window.open('https://www.instagram.com/dramcapital/');
    return;
  }
  openFacebook() {
    window.open('https://www.facebook.com/DramCapital');
    return;
  }
  scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
